import React, { useState,useRef } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Tab,
  Tabs
} from "react-bootstrap";
import { FiEyeOff } from "react-icons/fi";
import { FiImage } from "react-icons/fi";
export default function AddEmployeeModal({ show, handleClose }) {

  const [tab, setTab] = useState("basic");
  // const [image, setImage] = useState(null);

  // const handleImage = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImage(URL.createObjectURL(file));
  //   }
  // };
   const fileInputRef = useRef(null);

  // Default Image
  const [image, setImage] = useState(
    "https://i.pravatar.cc/150?img=12"
  );

  const handleImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);

      // Save image locally
      localStorage.setItem("profileImage", imageUrl);
    }
  };

  return (
<Modal
  show={show}
  onHide={handleClose}
  size="lg"
  centered
>
      <Modal.Header closeButton>
        <Modal.Title>
          Edit New Employee
          <span className="ms-2 text-muted fs-6">
            Employee ID : EMP -0024
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* TABS */}
        <Tabs activeKey={tab} onSelect={(k) => setTab(k)} className="mb-3">

          {/* BASIC INFO */}
          <Tab eventKey="basic" title="Basic Information">

            {/* IMAGE UPLOAD */}
         <div
      style={{
        background: "#f8f9fb",
        border: "1px solid #ececec",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "20px",
        display: "flex",
        alignItems: "center",
        gap: "20px",
        flexWrap: "wrap",
      }}
    >
      {/* Profile Image */}
      <div
        style={{
          width: "90px",
          height: "90px",
          borderRadius: "50%",
          border: "1px dashed #d9d9d9",
          overflow: "hidden",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          position: "relative",
        }}
      >
        {image ? (
          <img
            src={image}
            alt="profile"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <FiImage size={28} color="#c4c4c4" />
        )}
      </div>

      {/* Content */}
      <div style={{ flex: 1, minWidth: "220px" }}>
        <h5
          style={{
            margin: 0,
            fontSize: "19px",
            fontWeight: "600",
            color: "#2f3134",
          }}
        >
          Upload Profile Image
        </h5>

        <p
          style={{
            marginTop: "6px",
            marginBottom: "16px",
            color: "#64748b",
            fontSize: "15px",
          }}
        >
          Image should be below 4 mb
        </p>

        {/* Hidden File Input */}
        <Form.Control
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleImage}
          style={{ display: "none" }}
        />

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          {/* Upload Button */}
          <button
            type="button"
            onClick={() => fileInputRef.current.click()}
            style={{
              background: "#ff6b1a",
              border: "none",
              color: "#fff",
              padding: "10px 22px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s",
            }}
          >
            Upload
          </button>

          {/* Cancel Button */}
          <button
            type="button"
            onClick={() =>
              setImage("https://i.pravatar.cc/150?img=12")
            }
            style={{
              background: "#fff",
              border: "1px solid #dcdcdc",
              color: "#111827",
              padding: "10px 22px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>

            {/* FORM */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>First Name *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Employee ID *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Joining Date *</Form.Label>
                  <Form.Control type="date" />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Username *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3 position-relative">
                  <Form.Label>Password *</Form.Label>
                  <Form.Control type="password" />
                  <FiEyeOff className="position-absolute top-50 end-0 me-3" />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3 position-relative">
                  <Form.Label>Confirm Password *</Form.Label>
                  <Form.Control type="password" />
                  <FiEyeOff className="position-absolute top-50 end-0 me-3" />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Company *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              {/* DROPDOWNS */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Department</Form.Label>
                  <Form.Select>
                    <option>All Departments</option>
                    <option>Developer</option>
                    <option>Executive</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Designation</Form.Label>
                  <Form.Select>
                    <option>All Designation</option>
                    <option>Developer</option>
                    <option>Executive</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group>
                  <Form.Label>About *</Form.Label>
                  <Form.Control as="textarea" rows={3} />
                </Form.Group>
              </Col>
            </Row>
          </Tab>

          {/* PERMISSIONS TAB */}
          <Tab   eventKey="permissions" title="Permissions">

            <div className="p-3 border rounded bg-light mb-3 d-flex justify-content-between">
              <strong>Enable Options</strong>
              <div>
                <Form.Check inline type="switch" label="Enable all Module" />
                <Form.Check inline type="checkbox" label="Select All" />
              </div>
            </div>

            {[
              "Holidays",
              "Leaves",
              "Clients",
              "Projects",
              "Tasks",
              "Chats",
              "Assets",
              "Timing Sheets"
            ].map((item, i) => (
              <div key={i}  className="permission-row d-flex align-items-center flex-wrap gap-3">

                <Form.Check type="switch" label={item} />

                {["Read", "Write", "Create", "Delete", "Import", "Export"].map((perm, j) => (
                  <Form.Check key={j} type="checkbox" label={perm} />
                ))}
              </div>
            ))}

          </Tab>

        </Tabs>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
    <Button className="border border-1" style={{ background: "#ff6b1a", color:"#fff"}} >
          Save
        </Button>
      </Modal.Footer>
      <style>
          {
               `
               /* ============================= */
/* 🔶 GLOBAL ORANGE COLOR */
/* ============================= */
:root {
  --orange: #f26522;
}

/* ============================= */
/* 🔶 CHECKBOX */
/* ============================= */
.form-check-input:checked {
  background-color: var(--orange) !important;
  border-color: var(--orange) !important;
}

.form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(242, 101, 34, 0.25) !important;
  border-color: var(--orange) !important;
}

/* 🔶 Active tab (Permissions or any selected tab) */
.nav-tabs .nav-link.active {
  color: #f26522 !important;        /* ORANGE TEXT */
  border-color: #dee2e6 #dee2e6 #fff;
  font-weight: 600;
}

/* 🔶 Optional: hover effect */
.nav-tabs .nav-link:hover {
  color: #f26522 !important;
}

/* 🔶 Optional: remove blue focus */
.nav-tabs .nav-link:focus {
  box-shadow: none !important;
}
/* ============================= */
/* 🔶 SWITCH (TOGGLE) */
/* ============================= */
.form-switch .form-check-input {
  width: 42px;
  height: 22px;
}

/* OFF state */
.form-switch .form-check-input {
  background-color: #ddd;
  border: none;
}

/* ON state (ORANGE) */
.form-switch .form-check-input:checked {
  background-color: var(--orange) !important;
}

/* remove default blue shadow */
.form-switch .form-check-input:focus {
  box-shadow: none !important;
}

/* ============================= */
/* 🔶 LABEL SPACING */
/* ============================= */
.form-check-label {
  margin-left: 5px;
}

/* ============================= */
/* 🔶 PERMISSION ROW DESIGN */
/* ============================= */
.permission-row {
  border: 1px solid #e5e5e5;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
  background: #fff;
}

/* ============================= */
/* 🔶 ENABLE OPTIONS BOX */
/* ============================= */
.enable-box {
  background: #f8f9fa;
  border: 1px solid #e5e5e5;
  padding: 12px;
  border-radius: 8px;
}`
          }
      </style>
    </Modal>
  );
}